import React, { Fragment } from "react"
import classnames from "classnames"

import styles from "./styles.css"

const InvoicesSkeleton = () => {
  const formClasses = classnames(styles.skeletonForm, styles.skeleton)

  const moreOptionsClasses = classnames(
    styles.commons,
    styles.moreOptionsSkeleton,
    styles.whiteBackgroundSkeleton
  )

  const containerMoreItemClasses = classnames(
    styles.containerItem,
    styles.moreOptionItem,
    styles.skeleton
  )

  const textClasses = classnames(styles.textSkeleton, styles.skeleton)

  return (
    <Fragment>
      <div className={moreOptionsClasses}>
        <div className={formClasses}></div>
        <div className={styles.containerCards}>
          <div className={containerMoreItemClasses}></div>
          <div className={containerMoreItemClasses}></div>
        </div>
        <div className={textClasses}></div>
      </div>
    </Fragment>
  )
}

export default InvoicesSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/InvoicesSummarySkeleton/index.js